import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { TableStyled } from '../../active-requisition/styled';

export const RequisitionDetailsWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-grow: 1;
    overflow: auto;
    max-height: 100%;
    max-width: calc(100vw - 430px);
  `}
`;

export const TableStyledExt = styled(TableStyled)`
  ${({ theme }) => css`
    tfoot {
      position: sticky;
      bottom: 0;
      left: 0;
      td {
        font-weight: 600;
        font-size: ${theme.fontSizes[400]};
        background: ${theme.colors.grey[100]};
        &:first-child,
        &:last-child {
          background: ${theme.colors.grey[100]};
        }
      }
      &::before {
        content: '';
        display: block;
        height: 1px;
        background: ${theme.colors.grey[300]};
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    td {
      font-size: ${theme.fontSizes[400]};
      background: ${theme.colors.grey[50]};
      &:first-child {
        background: white;
      }
    }
  `}
`;

export const ReqDetailFooterStyled = styled(Box).attrs({ p: { sm: '500' }, justifyContent: { sm: 'flex-end' } })`
  ${({ theme }) => {
    return css`
      box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.2);
    `;
  }}
}`;
